import React from 'react';

const CircleCheck = () => {
  return (
    <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#vuzs5flkla)">
        <path
          d="M91.914 129.414a6.201 6.201 0 0 1-8.828 0l-25-25a6.201 6.201 0 0 1 0-8.828 6.201 6.201 0 0 1 8.828 0L87.5 116.172l45.586-45.586a6.201 6.201 0 0 1 8.828 0 6.201 6.201 0 0 1 0 8.828l-50 50zM200 100c0 55.234-44.766 100-100 100S0 155.234 0 100 44.766 0 100 0s100 44.766 100 100zM100 12.5c-48.32 0-87.5 39.18-87.5 87.5s39.18 87.5 87.5 87.5 87.5-39.18 87.5-87.5-39.18-87.5-87.5-87.5z"
          fill="#00AE49"
        />
      </g>
      <defs>
        <clipPath id="vuzs5flkla">
          <path fill="#fff" d="M0 0h200v200H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CircleCheck;
